export const MAX_BYTES_SIZE = 50000000;
export const MAX_MB_SIZE = 50;
export const MAX_FILES_AMOUNT = 10;
export const IMAGE_TYPES = ['png', 'jpg', 'jpeg', 'gif'];
export const VIDEO_TYPES = ['mp4', 'm4v'];
export const EXCEL_TYPES = ['xlsx', 'xls', 'xlsm', 'csv'];
export const POWERPOINT_TYPES = ['pptx', 'ppt'];
export const PDF_TYPES = ['pdf'];
export const WORD_TYPES = ['docx', 'doc'];
export const DOCUMENT_TYPES = [...EXCEL_TYPES, ...POWERPOINT_TYPES, ...PDF_TYPES, ...WORD_TYPES, 'msg', 'txt'];
export const FILE_TYPES = IMAGE_TYPES.concat(VIDEO_TYPES, DOCUMENT_TYPES);
